// import * as Sentry from '@sentry/react';

/**
 * @typedef {Object} TrackOptions
 * @property {Sentry.Severity} [level] - 日志级别
 * @property {Object.<string, string>} [tags] - 标签
 * @property {Object.<string, any>} [extra] - 额外信息
 */

class SentryTracker {
  // 记录普通事件
  static captureEvent(message, email) {
    window.Sentry.captureMessage(message, {
      tags: {
        method: 'email',
        email,
      },
    });
  }

  // 记录调试日志
  static captureDebug(...message) {
    console.debug('sentry debug: ', ...message);
    window.Sentry.captureMessage(message.join(' '), 'debug');
  }

  // 记录错误
  static captureError(error) {
    console.error(error);
    window.Sentry.captureException(error);
  }

  // 设置用户信息
  static setUser({ email }) {
    const u = {
      ...window.Sentry.getIsolationScope().getUser(),
      email,
    };
    window.Sentry.setUser(u);
    window.Sentry.getGlobalScope().setUser(u);
    window.Sentry.setTag('userId', u.email);
    window.Sentry.setTag('email', u.email);
    window.gtag('set', { email: u.email });
  }

  // 清除用户信息
  static clearUser() {
    window.Sentry.setUser(null);
  }
}

export default SentryTracker;
